import { useMemo } from "react";
import { MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";

export function useClientNutritionFolderDragKit() {
  const touchSensorOptions = useMemo(
    () => ({
      activationConstraint: {
        delay: 200,
        tolerance: 8,
      },
    }),
    [],
  );
  const mouseSensorOptions = useMemo(
    () => ({
      activationConstraint: {
        distance: 8,
      },
    }),
    [],
  );
  const touchSensor = useSensor(TouchSensor, touchSensorOptions);
  const mouseSensor = useSensor(MouseSensor, mouseSensorOptions);

  return {
    sensors: useSensors(touchSensor, mouseSensor),
  };
}

export default useClientNutritionFolderDragKit;
